import { Trans } from '@lingui/react'
import Alert from '@material-ui/lab/Alert'
import * as React from 'react'

export interface NotValidProps {
  message?: string
}

const NotValid: React.SFC<NotValidProps> = ({ message }) => {
  return (
    <div style={{ padding: '20px' }}>
      <h3 id='notValidHeader'>No podemos atender su petición en este momento</h3>
      <p>
        <Trans
          id=''
          message='Estimado usuario, su sala de Teleconsulta no ha podido iniciar por alguno de los siguientes inconveniente:'
        />
      </p>
      {!message && (
        <Alert id='alertError' severity='error'>
          <Trans id='' message='Datos de acceso son incorrectos.' />
        </Alert>
      )}
      {message && (
        <Alert id='alertError' severity='error'>
          {message}
        </Alert>
      )}
    </div>
  )
}

export default NotValid
